import { FlightSegment, JsonsData } from '@/src/types/flight'
import { getHoursAndMinutes, TransformedLayoverData } from '../itinerary/flightTransformers'

export function transformSRPLayoverData(
    currentSegment: FlightSegment,
    nextSegment: FlightSegment,
    layoverDurationMinutes: number,
    jsons: JsonsData
): TransformedLayoverData {
    const layoverType =
        currentSegment.flightNumber === nextSegment.flightNumber
            ? 'Technical layover'
            : layoverDurationMinutes <= 240
              ? 'Short layover'
              : 'Long layover'

    const layoverDurationSeconds = layoverDurationMinutes * 60

    const layoverDuration = getHoursAndMinutes(layoverDurationSeconds)
    const layoverAirport = jsons?.ap?.[currentSegment.arrival.airportCode]?.n || ''
    const airportCode = currentSegment.arrival.airportCode
    const cityName = jsons?.ap?.[currentSegment.arrival.airportCode]?.c || ''

    return {
        layoverType,
        layoverDuration,
        layoverAirport,
        airportCode,
        cityName
    }
}
